<template>
  <div class="content" id="mainContentId">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </transition>
    </div>
    <content-footer>
    </content-footer>
  </div>
</template>
<script>
  import ContentFooter from './ContentFooter.vue'

  export default {
    components: {ContentFooter}
  }
</script>
<!--<style>-->
<!--  .fade-enter-active,-->
<!--  .fade-leave-active {-->
<!--    transition: opacity .15s-->
<!--  }-->

<!--  .fade-enter,-->
<!--  .fade-leave-to-->
<!--    /* .fade-leave-active in <2.1.8 */-->

<!--  {-->
<!--    opacity: 0-->
<!--  }-->
<!--  @media screen and (min-width:0px) and (max-width: 573px) {-->
<!--    .content {-->
<!--      padding: 10px;-->
<!--      margin-top:60px;-->
<!--    }-->
<!--    .container-fluid {-->
<!--      padding-right:0;-->
<!--      padding-left:4px;-->
<!--    }-->
<!--  }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/Content.vue